// #viet_code
import React, { useState } from 'react';
import {
    Modal,
    Form as BootstrapForm,
    Row,
    Col,
    Tabs,
    Tab
} from 'react-bootstrap';
import { Formik, Form } from 'formik';
import * as yup from 'yup';
import { toast } from 'react-toastify';
import { useMutation, useQueryClient } from 'react-query';
import { Post, Put } from '@app/utils/httpProvider';
import {
    MAINTENANCE_EVENT_API
} from '@app/utils/apiUrl';
import { messageError, messageToast } from '../../../utils/define';
import HorizontalFieldsRow from '@app/components/common/HorizontalFieldsRow';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import Select from 'react-select';
import MaintenanceEventMaterialTable from '../../maintenanceEvent/components/MaintenanceEventMaterialTable';

const schema = yup.object().shape({
    eventCode: yup.string().required(messageError.emptyMessage),
    eventName: yup.string().required(messageError.emptyMessage)
});

const statusOptions = [
    { value: 'Chờ phê duyệt', label: 'Chờ phê duyệt' },
    { value: 'Đã phê duyệt', label: 'Đã phê duyệt' },
    { value: 'Không phê duyệt', label: 'Không phê duyệt' },
    { value: 'Đã sửa chữa', label: 'Đã sửa chữa' }
];

const eventTypeOptions = [
    { value: 'Sửa chữa', label: 'Sửa chữa' },
    { value: 'Bảo dưỡng định kỳ', label: 'Bảo dưỡng định kỳ' },
    { value: 'Bảo hành', label: 'Bảo hành (nhà cung cấp)' },
    { value: 'Nâng cấp', label: 'Nâng cấp' }
];

const MaintenanceEventModal = ({
    show,
    onHide,
    onSuccess,
    assetId,
    editItem
}) => {
    const isEdit = !!editItem;
    const queryClient = useQueryClient();
    const [activeTab, setActiveTab] = useState('general');

    const createFunc = useMutation((value) =>
        Post(MAINTENANCE_EVENT_API.ADD_ITEM, null, value)
    );

    const updateFunc = useMutation((value) =>
        Put(`${MAINTENANCE_EVENT_API.UPDATE_ITEM}/${editItem?.id}`, null, value)
    );

    const handleSubmit = async (values) => {
        const model = {
            ...values,
            assetId: Number(assetId),
            cost: values.cost ? Number(values.cost) : 0,
            repairCount: values.repairCount ? Number(values.repairCount) : 1,
            id: isEdit ? editItem.id : 0
        };

        const mutation = isEdit ? updateFunc : createFunc;

        mutation.mutate(model, {
            onSuccess: (res) => {
                queryClient.invalidateQueries('maintenanceEventData');
                toast.success(
                    isEdit
                        ? messageToast.messageToastUpdateSuccess
                        : messageToast.messageToastCreateSuccess
                );
                onSuccess();
            },
            onError: (err) => {
                toast.error(err?.message || 'Thao tác thất bại!');
            }
        });
    };

    return (
        <Modal
            show={show}
            onHide={onHide}
            size="xl"
            centered
            enforceFocus={false}
        >
            <Modal.Header className="custom-close-modal">
                <Modal.Title>
                    {isEdit
                        ? 'Cập nhật phiếu sửa chữa & Bảo trì'
                        : 'Thêm mới phiếu sửa chữa & Bảo trì'}
                </Modal.Title>
                <button
                    type="button"
                    className="close"
                    onClick={onHide}
                >
                    <span aria-hidden="true">&times;</span>
                </button>
            </Modal.Header>
            <Modal.Body
                style={{
                    maxHeight: '80vh',
                    minHeight: '500px',
                    overflowY: 'auto'
                }}
            >
                <Tabs
                    activeKey={activeTab}
                    onSelect={(k) => setActiveTab(k)}
                    className="mb-3"
                >
                    <Tab eventKey="general" title="1. Thông tin chung">
                        <Formik
                            enableReinitialize
                            validationSchema={schema}
                            onSubmit={handleSubmit}
                            initialValues={{
                                eventCode: editItem?.eventCode || `SC-${new Date().getTime()}`,
                                eventName: editItem?.eventName || '',
                                eventDate: editItem?.eventDate
                                    ? moment(editItem.eventDate).toDate()
                                    : new Date(),
                                endDate: editItem?.endDate
                                    ? moment(editItem.endDate).toDate()
                                    : null,
                                eventType: editItem?.eventType || 'Sửa chữa',
                                frequency: editItem?.frequency || '',
                                performedBy: editItem?.performedBy || '',
                                description: editItem?.description || '',
                                result: editItem?.result || '',
                                cost: editItem?.cost || 0,
                                repairCount: editItem?.repairCount || 1,
                                deviceError: editItem?.deviceError || '',
                                status: editItem?.status || 'Chờ phê duyệt',
                                approvedBy: editItem?.approvedBy || '',
                                isExternalRepair: editItem?.isExternalRepair || false,
                                note: editItem?.note || ''
                            }}
                        >
                            {({
                                handleSubmit: formSubmit,
                                handleChange,
                                values,
                                errors,
                                setFieldValue
                            }) => (
                                <Form noValidate onSubmit={formSubmit}>
                                    <HorizontalFieldsRow
                                        labelCol={4}
                                        inputCol={8}
                                        fields={[
                                            {
                                                label: 'Mã phiếu sửa chữa',
                                                name: 'eventCode',
                                                value: values.eventCode,
                                                onChange: handleChange,
                                                isInvalid: !!errors.eventCode,
                                                error: errors.eventCode,
                                                readOnly: true
                                            },
                                            {
                                                label: 'Tên công việc / Sự kiện',
                                                name: 'eventName',
                                                value: values.eventName,
                                                onChange: handleChange,
                                                isInvalid: !!errors.eventName,
                                                error: errors.eventName,
                                                placeholder: 'Ví dụ: Bảo dưỡng định kỳ máy phát điện...'
                                            }
                                        ]}
                                    />

                                    <HorizontalFieldsRow
                                        labelCol={4}
                                        inputCol={8}
                                        fields={[
                                            {
                                                label: 'Loại hình',
                                                name: 'eventType',
                                                component: (
                                                    <Select
                                                        options={eventTypeOptions}
                                                        value={eventTypeOptions.find((o) => o.value === values.eventType)}
                                                        onChange={(opt) => setFieldValue('eventType', opt ? opt.value : '')}
                                                    />
                                                )
                                            },
                                            {
                                                label: 'Người thực hiện',
                                                name: 'performedBy',
                                                value: values.performedBy,
                                                onChange: handleChange,
                                                placeholder: 'Tên kỹ thuật viên...'
                                            }
                                        ]}
                                    />

                                    <HorizontalFieldsRow
                                        labelCol={4}
                                        inputCol={8}
                                        fields={[
                                            {
                                                label: 'Ngày thực hiện (Bắt đầu)',
                                                name: 'eventDate',
                                                component: (
                                                    <DatePicker
                                                        wrapperClassName="w-100"
                                                        className="form-control"
                                                        selected={values.eventDate}
                                                        onChange={(date) => setFieldValue('eventDate', date)}
                                                        dateFormat="dd/MM/yyyy"
                                                        minDate={new Date()}
                                                    />
                                                )
                                            },
                                            {
                                                label: 'Hạn hoàn thành (Dự kiến)',
                                                name: 'endDate',
                                                component: (
                                                    <DatePicker
                                                        wrapperClassName="w-100"
                                                        className="form-control"
                                                        selected={values.endDate}
                                                        onChange={(date) => setFieldValue('endDate', date)}
                                                        dateFormat="dd/MM/yyyy"
                                                        placeholderText="Chọn ngày..."
                                                        isClearable
                                                        minDate={values.eventDate || new Date()}
                                                    />
                                                )
                                            }
                                        ]}
                                    />

                                    <HorizontalFieldsRow
                                        labelCol={4}
                                        inputCol={8}
                                        fields={[
                                            {
                                                label: 'Lần sửa chữa thứ',
                                                name: 'repairCount',
                                                type: 'number',
                                                min: 0,
                                                value: values.repairCount,
                                                onChange: handleChange
                                            },
                                            {
                                                label: 'Tần suất bảo trì',
                                                name: 'frequency',
                                                value: values.frequency,
                                                onChange: handleChange,
                                                placeholder: 'Ví dụ: 6 tháng/lần'
                                            }
                                        ]}
                                    />

                                    <HorizontalFieldsRow
                                        labelCol={4}
                                        inputCol={8}
                                        fields={[
                                            {
                                                label: 'Trạng thái',
                                                name: 'status',
                                                component: (
                                                    <Select
                                                        options={statusOptions}
                                                        value={statusOptions.find((o) => o.value === values.status)}
                                                        onChange={(opt) => setFieldValue('status', opt ? opt.value : '')}
                                                    />
                                                )
                                            },
                                            {
                                                label: 'Chi phí (VNĐ)',
                                                name: 'cost',
                                                type: 'number',
                                                min: 0,
                                                value: values.cost,
                                                onChange: handleChange
                                            }
                                        ]}
                                    />

                                    <BootstrapForm.Group as={Row} className="mb-3 mt-3 align-items-center m-0 w-100">
                                        <BootstrapForm.Label column sm={2} className="text-right fw-bold">Lỗi thiết bị (nếu có)</BootstrapForm.Label>
                                        <Col sm={10}>
                                            <BootstrapForm.Control as="textarea" rows={2} name="deviceError" value={values.deviceError} onChange={handleChange} placeholder="Mô tả chi tiết lỗi của thiết bị..." />
                                        </Col>
                                    </BootstrapForm.Group>

                                    <BootstrapForm.Group as={Row} className="mb-3 m-0 w-100">
                                        <Col sm={{ span: 10, offset: 2 }} className="icheck-primary">
                                            <BootstrapForm.Check
                                                id="isExternalRepairModal"
                                                type="checkbox"
                                                label={<span className="text-danger font-weight-bold">Mang ra ngoài sửa chữa (Sửa ngoài công ty)</span>}
                                                name="isExternalRepair"
                                                checked={values.isExternalRepair}
                                                onChange={handleChange}
                                            />
                                        </Col>
                                    </BootstrapForm.Group>

                                    <HorizontalFieldsRow
                                        labelCol={4}
                                        inputCol={8}
                                        fields={[
                                            {
                                                label: 'Nội dung sửa chữa',
                                                name: 'description',
                                                component: (
                                                    <BootstrapForm.Control as="textarea" rows={3} name="description" value={values.description} onChange={handleChange} placeholder="Nội dung thực hiện..." />
                                                )
                                            },
                                            {
                                                label: 'Kết quả / Ghi chú',
                                                name: 'result',
                                                component: (
                                                    <BootstrapForm.Control as="textarea" rows={3} name="result" value={values.result} onChange={handleChange} placeholder="Kết quả / Ghi chú bổ sung..." />
                                                )
                                            }
                                        ]}
                                    />

                                    <div className="text-right mt-3">
                                        <button
                                            type="submit"
                                            className="btn btn-primary mr-2"
                                        >
                                            <i className="fas fa-save mr-1" />{' '}
                                            {isEdit ? 'Cập nhật' : 'Lưu phiếu'}
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-secondary"
                                            onClick={onHide}
                                        >
                                            Hủy
                                        </button>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </Tab>

                    {isEdit && (
                        <Tab eventKey="materials" title="2. Vật tư thực tế">
                            <MaintenanceEventMaterialTable
                                eventId={editItem.id}
                            />
                        </Tab>
                    )}
                </Tabs>
            </Modal.Body>
        </Modal>
    );
};

export default MaintenanceEventModal;
